<template>
  <v-card-actions>
    <Confirm @confirmed="toggleBillingStatus">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" v-if="sample.billing_approved" tile color="primary" small class="mr-2" :loading="billing_status.loading" :disabled="billing_status.loading">Unapprove Billing</v-btn>
        <v-btn v-on="on" v-else tile color="primary" small :loading="billing_status.loading" class="mr-2" :disabled="billing_status.loading">Approve Billing</v-btn>
      </template>
    </Confirm>
<!--    <ReleaseSample ref="release_sample" v-if="sample.qa_approved && sample.order_id" :sample="sample" @has_released="hasBeenReleaseBefore = true"></ReleaseSample>-->
<!--    <v-btn v-else disabled tile small>Release</v-btn>-->
    <ReleaseIndividual v-if="sample.qa_approved && sample.order_id" :sample="sample"></ReleaseIndividual>
    <v-btn v-else disabled tile small>Release</v-btn>
    <CheckHidden v-if="sample.is_released || hasBeenReleaseBefore" class="mr-2 ml-2" :sample_uuid="sample.uuid" ></CheckHidden>
    <SampleCertView v-if="sample.is_released || hasBeenReleaseBefore" :sample_id="sample.id">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" tile color="primary" small class="mr-2 ml-2" :disabled="$store.state.testing">Cert</v-btn>
      </template>
    </SampleCertView>
    <v-btn v-else  :disabled="!sample.is_released" tile color="primary" small class="mr-2 ml-2">Cert</v-btn>
    <v-btn :disabled="!sample.is_released || (regenCert.loading || regenCert.onCoolDown) || $store.state.testing" @click="regenerateCert" tile color="primary" small class="mr-2" :loading="regenCert.loading || regenCert.onCoolDown">
      <template v-slot:loader>
        Regen Cert
        <v-progress-circular :indeterminate="regenCert.loading" :value="(regenCert.countDown/regenCert.coolDown)*100" size="25" width="2">
          <template v-if="regenCert.onCoolDown && !regenCert.loading">{{regenCert.countDown}}</template>
        </v-progress-circular>
      </template>
      Regenerate Cert
    </v-btn>
    <v-dialog v-model="showRegenLink" max-width="500">
      <v-card>
        <CardTitle title="Regen Cert Failure"></CardTitle>
        <v-card-text>
          <a :href="regenLink" target="_blank" @click="showRegenLink = false">Click here to regenerate cert.</a>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-btn :disabled="!sample.qa_approved || qa_unapprove.loading" tile color="primary" small class="mr-2" :loading="qa_unapprove.loading">QA Unapprove</v-btn>
    <SdpView v-if="sample.qa_approved && sample.sample_tests.find(t => t.test_type.name === 'T')" :sample_id="sample.id">
      <template v-slot:activator="{on}">
        <SdpButton v-on="on"  :sample_id="sample.id" class="mr-2 ml-2" tile small :key="sample.id"></SdpButton>
      </template>
    </SdpView>
    <LogsV1 :sample="sample">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" :disabled="$store.state.testing" small tile>V1 Logs</v-btn>
      </template>
    </LogsV1>
    <LogsV2 :log_props="{query_uuid: sample.uuid, query_uuid_keys: ['sample_uuid']}">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" :disabled="$store.state.testing" small tile>V2 Logs</v-btn>
      </template>
    </LogsV2>
    <v-spacer></v-spacer>
    <DeleteSample :sample="{uuid: sample.uuid, id: sample.id, qa_approved: sample.qa_approved, released: sample.released}"></DeleteSample>
  </v-card-actions>
</template>

<script>
import axios from 'axios';
import SdpView from '@/components/SDP/SdpView'
import SdpButton from '@/components/SDP/SdpButton'
export default {
    name: "SampleDropdownActionBar",
    components: {
      SampleCertView: () => import("@/components/general/samples/SampleCertView"),
      ReleaseSample: () => import('@/views/ReleaseV2/components/ReleaseSample'),
      ReleaseIndividual: () => import('./ReleaseIndividual'),
      LogsV2: () => import("@/components/logs/V2/LogDialog"),
      LogsV1: () => import("@/components/logs/logs"),
      CheckHidden: () => import("./CheckHidden"),
      DeleteSample: () => import("./DeleteSample"),
      SdpButton,
      SdpView,
    },
    props:{
      sample: {
        required: true
      }
    },
    data: () => ({
      interval: null,
      hasBeenReleaseBefore: false,
      showRegenLink: false,
      releasedSample: {
        loading: false,
        listener: null,
        data: null,
      },
      regenCert: {
        loading: false,
        onCoolDown: false,
        coolDown: 60,
        countDown: 60,
      },
      qa_unapprove:{
        loading: false
      },
      billing_status:{
        loading: false,
      }
    }),
    mounted(){
      console.log(this.sample, 'SAMPLE ACTION BAR')
      this.interval = setInterval(() => {
        this.cerRegenIntervalFunction();
      }, 1000)
    },
    computed: {
      regenLink(){
        return `https://certs.conflabs.com/queueReported/?sample_uuid=${this.sample.uuid}&conan_sample_id=${this.sample.id}`
      },
    },
    methods: {
      cerRegenIntervalFunction () {
        if(!this.regenCert.onCoolDown) return;
        if(this.regenCert.countDown <= 0){
          this.regenCert.onCoolDown = false;
          this.regenCert.countDown = this.regenCert.coolDown;
        }else{
          this.regenCert.countDown -= 1;
        }
      },
      async toggleBillingStatus(){
        this.billing_status.loading = true
        await this.$store.$db().model('samples').api().save({
          uuid: this.sample.uuid,
          id: this.sample.id,
          billing_approved: !this.sample.billing_approved,
          updated_by: this.$store.getters.id
        })
        this.billing_status.loading = false
      },
      async regenerateCert(){
        this.regenCert.loading = true;
        this.regenCert.onCoolDown = true;
        try{
          await axios.get("https://certs.conflabs.com/full/delete/WA-nGzcGwV6vrwJ-WA-220119-017.pdf")
          await this.$store.dispatch("showSuccess", "Cert is regenerating for: "+this.sample.id)
        }catch(e){
          console.log(e);
          this.regenCert.onCoolDown = false;
          this.showRegenLink = true;
          await this.$store.dispatch("showError", "Failed to make a call to regenerate cert.")
        }finally{
          this.regenCert.loading = false;
        }

      }
    },
    beforeDestroy() {
      clearInterval(this.interval);
    }
}
</script>

<style scoped>

</style>
